import { render, staticRenderFns } from "./formSearch.vue?vue&type=template&id=6b0cdb71&scoped=true"
import script from "./formSearch.vue?vue&type=script&lang=js"
export * from "./formSearch.vue?vue&type=script&lang=js"
import style0 from "./formSearch.vue?vue&type=style&index=0&id=6b0cdb71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0cdb71",
  null
  
)

export default component.exports